module.exports = __webpack_public_path__ + "static/img/mobile-web-img-03@m.11052ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/mobile-web-img-03@m.png
// module id = ykIl
// module chunks = 0